import script from "./pdfvVew.vue?vue&type=script&setup=true&lang=js"
export * from "./pdfvVew.vue?vue&type=script&setup=true&lang=js"

import "./pdfvVew.vue?vue&type=style&index=0&id=5bf13515&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bf13515"]])

export default __exports__